<template>
    <div class="card bg-gradient-danger">
        <div class="card-body">
            <h3 class="card-title text-white">{{ $t('auth.change-your-password') }}</h3>
            <blockquote class="blockquote text-white mb-0">
                <p>{{ $t('auth.change-your-password-description') }}</p>
            </blockquote>
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>

